import React from 'react';
import PropTypes from 'prop-types';
import './LinkPopup.scss';

const LinkPopup = ({ imgSrc, imgAlt }) => {
  return (
    <a
      href="https://lenceriamaguen.ar/"
      className="link-popup"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={imgSrc} alt={imgAlt} className="link-popup-img" />
    </a>
  );
};

LinkPopup.defaultProps = {
  imgSrc: '/files/mayorista.png',
  imgAlt: 'Popup Image',
};

LinkPopup.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string,
};

export default LinkPopup;
